import { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LoginForm from '../LoginForm/LoginForm';
import RegisterForm from '../RegisterForm/RegisterForm';
import Button from '../UI/Button/Button';
import styles from './AuthLayout.module.css';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectAuth } from '../../redux/slices/auth';

function AuthLayout() {
    const [isLogin, setIsLogin] = useState(true);
    const [isRotating, setIsRotating] = useState(false);
    const cubeRef = useRef(null);
    const auth = useSelector(selectAuth);
    const navigate = useNavigate();

    console.log(auth);

    useEffect(() => {
        if (auth?.user) {
            navigate('/crm/ideas');
        }
    }, [auth?.user, navigate]);

    const { t } = useTranslation('auth');

    const getRandomRotation = () => {
        // Базовое вращение всегда 180deg по Y (переворот на другую сторону)
        // Добавляем только небольшие наклоны для разнообразия
        const tilts = [
            { x: 0, z: 0 },
            { x: 12, z: 0 },
            { x: -12, z: 0 },
            { x: 0, z: 8 },
            { x: 0, z: -8 },
            { x: 10, z: 5 },
            { x: -10, z: -5 },
        ];

        const tilt = tilts[Math.floor(Math.random() * tilts.length)];
        let rotation = 'rotateY(180deg)';

        if (tilt.x !== 0) {
            rotation += ` rotateX(${tilt.x}deg)`;
        }
        if (tilt.z !== 0) {
            rotation += ` rotateZ(${tilt.z}deg)`;
        }

        return rotation;
    };

    const handleToggle = () => {
        if (isRotating) return;
        setIsRotating(true);

        const randomRotation = getRandomRotation();

        // Применяем случайную ротацию
        if (cubeRef.current) {
            cubeRef.current.style.transform = randomRotation;
        }

        setTimeout(() => {
            setIsLogin(!isLogin);
            // Убираем inline стиль, чтобы класс .rotated работал
            setTimeout(() => {
                if (cubeRef.current) {
                    cubeRef.current.style.transform = '';
                }
                setIsRotating(false);
            }, 50);
        }, 600);
    };

    return (
        <div
            className={styles.container}
            style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/assets/auth-background.png)`,
            }}
        >
            <div className={styles.cubeContainer}>
                <div
                    ref={cubeRef}
                    className={`${styles.cube} ${isLogin ? '' : styles.rotated}`}
                >
                    <div className={`${styles.cubeFace} ${styles.cubeFaceFront}`}>
                        <div className={styles.authBox}>
                            <LoginForm />
                            <Link to="/events" className={styles.eventsLink}>
                                {t('view_events')}
                            </Link>
                            <Button
                                variant="primary"
                                onClick={handleToggle}
                                disabled={isRotating}
                                className={styles.toggleButton}
                            >
                                {t('register.title')}
                            </Button>
                        </div>
                    </div>
                    <div className={`${styles.cubeFace} ${styles.cubeFaceBack}`}>
                        <div className={styles.authBox}>
                            <RegisterForm onGoToLogin={handleToggle} />
                            <Link to="/events" className={styles.eventsLink}>
                                {t('view_events')}
                            </Link>
                            <Button
                                variant="warning"
                                onClick={handleToggle}
                                disabled={isRotating}
                                className={styles.toggleButton}
                            >
                                {t('login.title')}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AuthLayout;